<template>
		<!-- Dialog de opciones -->
		<v-dialog
			class="tile"
			v-model="dialogCambioCarrito"
			max-width="600"
			scrollable
			:fullscreen="$vuetify.breakpoint.smAndDown"
		>
			<v-card>

				<v-card-title class="pa-0">
					
					<!-- Botones superiores del modal -->
					<v-btn
						width="40"
						height="40"
						elevation="3"
						icon
						color="#ffffff"
						style="background-color:white;"
						small
						absolute
						right
						top
						@click="dialogCambioCarrito = false"
					>
						<v-icon class="black--text ma-auto">mdi-close</v-icon>
					</v-btn>

					<v-col cols="12" class="pa-4 pa-sm-6 d-flex" align="center" justify="center">
						<span class="text-truncate" style="max-width: 90%">
							Su carrito ha cambiado
						</span>
					</v-col>
				
				</v-card-title>

				<v-card-subtitle
					class="body-1 text-left black--text text--darken-1 py-2 px-6 my-0"
					style="background-color: #eaeaea"
				>
					Algo ha cambiado desde su última visita
				</v-card-subtitle>
				<v-card-text
					class="pa-0 d-flex"
				>
					<v-container>
						<v-row>

							<v-list-item
								class="mx-4 px-0"
								v-for="(prod,i) in cambioCarrito"
								:key="i"
								:index="items"
							>
								<v-list-item-action
								class="d-flex mx-0 mt-3 mb-auto pa-0"
								style="width:40px"
								:class="prod.modificado ? 'font-weight-bold' : 'font-weight-light'">
									<v-row class="" no-gutters>
										<v-col class="pa-0 d-flex align-center justify-center" cols="12">
											<span>{{ prod.cantidad }}</span>
										</v-col>

									</v-row>
								</v-list-item-action>
								<v-list-item-content
								:class="prod.modificado ? 'font-weight-bold' : 'font-weight-light'">
									<v-list-item-title class=" mb-auto">{{ prod.nombre }}</v-list-item-title>
									<v-list-item-subtitle
									v-if="prod.opcionesName.length > 0"
									>

										<v-list-item
											v-for="opcion in prod.opcionesName"
											:key="opcion"
											style="min-height:20px;"
											>
											<v-list-item-content class="py-0">
												<v-list-item-subtitle class="body-2">{{opcion}}</v-list-item-subtitle>
											</v-list-item-content>
										</v-list-item>

									<!--{{ breadcrumbOpciones(prod.opciones) }}-->

									</v-list-item-subtitle>
								</v-list-item-content
								:class="prod.modificado ? 'font-weight-bold' : 'font-weight-light'">
								<v-list-item-content class="d-flex align-start" style="max-width:80px">
									<v-list-item-title
									class="text-right mb-auto"
									:class="prod.modificado ? 'font-weight-bold' : 'font-weight-light'"
									>
										{{ (prod.cantidad*(sumaOpciones(prod.opcionesPrecio)+parseFloat(prod.precio))).toFixed(2) }} €
										
									</v-list-item-title>
								</v-list-item-content>

							</v-list-item>
							
						</v-row>
					</v-container>
				</v-card-text>


				<v-card-actions class="pa-3">
					<v-container>
						<v-row no-gutters>
							<v-col cols="12" sm="6" class="d-flex align-center pa-0">
								<v-btn
									x-large
									tile
									class="ma-0 py-0"
									block
									color="default"
									v-bind:style=" $vuetify.breakpoint.smAndDown ? 'position:absolute;bottom:0px;left:0px;width:100%;right:0px;' : '' "
									@click="nuevoCarritoRechazado()"
								>
									Reiniciar
								</v-btn>
							</v-col>
							<v-col cols="12" sm="6" class="d-flex align-center pa-0">
								<v-btn
									x-large
									tile
									class="ma-0 py-0"
									block
									color="success"
									v-bind:style=" $vuetify.breakpoint.smAndDown ? 'position:absolute;bottom:0px;left:0px;width:100%;right:0px;' : '' "
									@click="nuevoCarritoAceptado()"
								>
									Aceptar
								</v-btn>
							</v-col>
						</v-row>
					</v-container>
				</v-card-actions>

			</v-card>
		</v-dialog>

</template>

<script>
import { mapState } from "vuex";
export default {
	name: "dialogCambioCarrito",
	data() {
		return {

		};
	},
	computed: {
		dialogCambioCarrito: {
			get() {
				return this.$store.state.pedido.dialogCambioCarrito;
			},
			set(val) {
				this.$store.commit("pedido/setDialogCambioCarrito", val);
			}
		},
		...mapState({
			cambioCarrito: state => state.pedido.cambioCarrito
		}),
	},
	methods: {
		sumaOpciones(array){
			if(array.length > 0){
				const reducer = (accumulator, currentValue) => accumulator + currentValue;
				return array.reduce(reducer);
			}else{
				return 0;
			}
			
		},
		nuevoCarritoAceptado(){
			let _vue = this;
			this.$store.commit("pedido/setCarrito", _vue.cambioCarrito);
			this.dialogCambioCarrito = false;

		},
		nuevoCarritoRechazado(){
			this.$store.commit("pedido/resetCarrito");
			this.dialogCambioCarrito = false;
		}
	}
};
</script>

<style scoped>
.v-banner--is-mobile div.v-banner__wrapper {
	padding: 0px !important;
}
.circle {
	border-radius: 50%;
}
#productDialog .v-card__actions {
	position: sticky;
	bottom: 0px;
	background: white;
}
.p-absolute {position: absolute;}
.p-sticky {
	position: sticky;
	border-bottom: 1px solid #dbdbdb;
	box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
}
.tile{border-radius: 0px;}
.bottom {bottom: 0px;}
.top {top: 0px;}
.index-1 {z-index: 1;}
.index-5 {z-index: 5;}
.overflow-x {overflow-x: hidden;}
.w-100 {width: 100%;}
.mw-100 {max-width: 100%;}
.vh-75 {
	height: 75vh;
}
.v-tabs:not(.v-tabs--vertical) .v-tab {
	white-space: nowrap;
	width: auto !important;
	text-transform: initial;
	color: rgba(0, 0, 0);
}
.v-dialog .v-card .v-card__actions {
	position: sticky;
	bottom: 0px;
}
.all-window-absolute {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0px;
}
/* Navbar categorias */
.card {
  background-color: #fff;
  min-width: 100%;
}
.card::-webkit-scrollbar {
  display: none;
}
.card--content{
	white-space: nowrap;
	width: auto !important;
	text-transform: initial;
	cursor: pointer;
}
.slider-wrapper{
	width: 100px;
	height: 2px;
	background-color: #4caf50;
	border: 1px solid #4caf50;
	position:absolute;
	bottom:0px;
	transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #f6f6f6 !important;
}

.v-list-item--link::before{background-color: transparent !important;}
.border{
	border: 1px solid black;
}
.v-tooltip__content{
	opacity: 1 !important;
}

@media only screen and (max-width: 992px) {
	.overflow-x {
		overflow-x: auto;
	}
}

</style>
